module.exports = __webpack_public_path__ + "img/instagram.184f7270.svg";